<template>
  <v-data-table
    dense
    :headers="headers"
    :items="value"
    :loading="loading"
    class="modern-table elevation-0"
    :items-per-page="5"
    :footer-props="{
      itemsPerPageOptions: [5, 10, 20]
    }"
  >
    <template v-slot:top>
      <div class="px-4 py-2 d-flex justify-end bg-light border-bottom">
        <address-create-update-2 :action="'create'" @created="fetch" :customerId="customerId"/>
      </div>
    </template>

    <template v-slot:item.name="{ item }">
      <v-chip
        label
        x-small
        outlined
        color="primary"
        class="font-weight-bold"
      >
        {{item.name}}
      </v-chip>
    </template>

    <template v-slot:item.street="{ item }">
      <div class="d-flex align-center font-weight-medium">
        <v-icon x-small class="mr-1 grey--text">fas fa-map-marker-alt</v-icon>
        <span class="body-2">{{item.street}} {{item.number}}</span>
      </div>
    </template>

    <template v-slot:item.region="{ item }">
      <span class="caption grey--text text--darken-2">{{item.region}}</span>
    </template>

    <template v-slot:item.comune="{ item }">
      <span class="caption grey--text text--darken-2">{{item.comune}}</span>
    </template>

    <template v-slot:item.city="{ item }">
      <span class="caption grey--text text--darken-2">{{item.city}}</span>
    </template>

    <template v-slot:item.actions="{item}">
      <address-create-update-2 :action="'edit'" v-model="item" @updated="fetch" @deleted="fetch" :customerId="customerId"/>
    </template>
  </v-data-table>
</template>

<script>
import AddressCreateUpdate2 from './AddressCreateUpdate2.vue';
import {fetchAddresses} from '@/api/customers';
import notifications from '@/utils/notifications';

export default {
  name: 'AddressList',
  components: {
    AddressCreateUpdate2
  },
  props: {
    value: Array,
    customerId: {
      type: Number,
      required: false,
    },
    embeded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    fetch() {
      if (!this.customerId) return;
      this.loading = true;
      const query = `?customer=${this.customerId}`;
      fetchAddresses(query)
      .then(response => {
        this.$emit('input', response);
      })
      .catch(error => {
        notifications.showError('Error cargando direcciones: ' + error)
      })
      .finally(() => {
        this.loading = false;
      })
    },
  },
  computed: {
    headers() {
      const { region_label, comune_label, city_label } = this.$store.getters.getInternational;
      return [
        { text: 'Nombre / Tag', value: 'name', align: 'start' },
        { text: 'Dirección', value: 'street', align: 'start' },
        { text: region_label || 'Departamento', value: 'region', align: 'start' },
        { text: comune_label || 'Provincia', value: 'comune', align: 'start' },
        { text: city_label || 'Distrito', value: 'city', align: 'start' },
        { text: '', value: 'actions', sortable: false, align: 'end', width: '60' }
      ]
    }
  }
};
</script>

<style scoped>
.modern-table {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 8px !important;
}
.bg-light { background-color: #fcfcfc; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.05); }
</style>